// extracted by mini-css-extract-plugin
export default {"reValidateCardSection":"A1-z","paymentSection":"B1-z","disabled":"C1-z","sectionButtons":"D1-z","usingAmazonPayMsg":"E1-z"};